import React from 'react'

import { Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

import InfoCircleTooltip from 'components/InfoCircleTooltip'
import Typography from 'components/Typography'
import { useEventContext } from 'context/EventContext'

import ProductCard from './components/ProductCard'

import classes from './TopFeaturedProducts.module.scss'

/* eslint-disable import/no-duplicates -- Swiper module CSS imports are side-effect imports. */
import 'swiper/css'
import 'swiper/css/pagination'
/* eslint-enable import/no-duplicates */

const SWIPER_BREAKPOINTS_CONFIG = {
  360: {
    slidesPerView: 1.2,
    centeredSlides: true,
    spaceBetween: 12,
  },
  600: {
    slidesPerView: 1.8,
    centeredSlides: false,
    spaceBetween: 24,
  },
  960: {
    slidesPerView: 2,
    centeredSlides: false,
    spaceBetween: 24,
  },
  1280: {
    slidesPerView: 3,
    centeredSlides: false,
    spaceBetween: 24,
  },
}

const TopFeaturedProducts = ({ listings }) => {
  const { sendEvent } = useEventContext()
  if (!listings.length) {
    return null
  }
  return (
    <div className={classes.root}>
      <Typography component="h2" className={classes.title}>
        Top featured products
        <InfoCircleTooltip
          enterTouchDelay={100}
          sendOnEnterEvents={() => {
            sendEvent({
              engagementComponent: 'featured-products',
              engagementDestination: 'show_top-featured-products-tooltip',
              engagementDetails: 'hover_icon',
              name: 'engagement_hover',
            })
          }}
          title={
            'Software providers pay us for featured placements to receive web traffic and sales opportunities. Featured placements include a link-out icon that takes users to the provider’s website.'
          }
        />
      </Typography>

      <div className={classes.carouselContainer}>
        <Swiper
          modules={[Pagination]}
          pagination={{ clickable: true, el: '#cr-product-pagination' }}
          breakpoints={SWIPER_BREAKPOINTS_CONFIG}
          simulateTouch={false}
        >
          {listings.map((listing, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <SwiperSlide key={`product_${index}`} className={classes.slide}>
              <ProductCard listing={listing} listingPosition={index} />
            </SwiperSlide>
          ))}
        </Swiper>
        <div id="cr-product-pagination" className={classes.pagination} />
      </div>
    </div>
  )
}
export default TopFeaturedProducts
